import React from "react";
import PropTypes from "prop-types";

import { Modal } from "@learningblocks/shared-components/lib/Modal";
import { OptionsSelectButton } from "../OptionsSelectButton";
import { Wrapper } from "./Wrapper";

import "./style.scss";

export function OptionsModal(props) {
  const className = `${props.className} optionsModalWindow`;
  return (
    <Modal
      isOpen={props.isOpen}
      close={props.close}
      closeButton={true}
      className={className}
    >
      {props.children}
      {!props.isOptionSelected && (
        <Wrapper className="optionsModalWindow_buttonWrapper">
          <OptionsSelectButton
            className="optionsModalWindow_buttonWrapper__button"
            text={props.buttonText}
            onClick={props.onSumbitSelection}
          />
        </Wrapper>
      )}
    </Modal>
  );
}

OptionsModal.propTypes = {
  /**
   * ClassName for OptionsModal
   */
  className: PropTypes.string,
  /**
   * Component/Components to display on Modal
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  /**
   * Boolean set/reset to open/close modal
   */
  isOpen: PropTypes.bool.isRequired,
  /**
   * Fuction to close modal
   */
  close: PropTypes.func,
  /**
   * Show closeButton or not
   */
  closeButton: PropTypes.bool,
  /**
   * text to be rendered inside of the button
   */
  buttonText: PropTypes.string,
  /**
   * To hide the button inside the options modal window
   */
  isOptionSelected: PropTypes.bool,
  /**
   * function to invoke on option select button click
   */
  onSumbitSelection: PropTypes.func,
};

OptionsModal.defaultProps = {
  className: "",
  isOptionSelected: false,
};
